import { render } from "./EnviroDetail.vue?vue&type=template&id=2c37faad&scoped=true&ts=true"
import script from "./EnviroDetail.vue?vue&type=script&lang=ts"
export * from "./EnviroDetail.vue?vue&type=script&lang=ts"

import "./EnviroDetail.vue?vue&type=style&index=0&id=2c37faad&lang=scss&scoped=true"

import exportComponent from "/Users/matustrebaticky/projects/symbiosy/insights/insights-fe/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c37faad"],['__file',"src/views/modules/insights/views/EnviroDetail.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2c37faad"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2c37faad', __exports__)) {
    api.reload('2c37faad', __exports__)
  }
  
  module.hot.accept("./EnviroDetail.vue?vue&type=template&id=2c37faad&scoped=true&ts=true", () => {
    api.rerender('2c37faad', render)
  })

}


export default __exports__